import axios from 'axios';
import config from '../config';
const baseUrl = `${config.apiUrl}/api/promotions`;

export const getPromotions = async ({
    page = 0,
    sort,
    filters,
    csv = false,
}) => {
    const sortParam =
        sort && sort.sortBy && sort.sortDirection
            ? `&sort=${sort.sortBy}&direction=${sort.sortDirection}`
            : '';
    const filterParam = filters
        ? `&${filters
              .filter((x) => x)
              .map((filter) => `${filter.name}=${filter.value}`)
              .join('&')}`
        : '';
    const url = `${baseUrl}?page=${page}${sortParam}${filterParam}`;
    if (csv) {
        return `${url}&csv=true`;
    } else {
        const {
            data: { results },
        } = await axios(url, {
            withCredentials: true,
        });
        return results;
    }
};
export const getPromotion = async (id) => {
    const {
        data: { results },
    } = await axios(`${baseUrl}/${id}`, {
        withCredentials: true,
    });
    return results;
};
export const savePromotion = async (promotion) => {
    const {
        data: { results },
    } = await axios.post(
        baseUrl,
        { promotion },
        {
            withCredentials: true,
        },
    );
    return results;
};
export const updatePromotion = async (id, promotion) => {
    const {
        data: { results },
    } = await axios.put(
        baseUrl,
        { id, promotion },
        {
            withCredentials: true,
        },
    );
    return results;
};
export const deletePromotion = async ({ id }) => {
    const {
        data: { results },
    } = await axios.request({
        method: 'delete',
        url: baseUrl,
        data: { id },
        withCredentials: true,
    });
    return results;
};
